export default __webpack_public_path__ + "static/media/10.9443f4cc.svg";